export const VERSION = '1.3.6'
// export const BASE_URL = 'http://localhost:5000' // For test env
// export const BASE_URL = 'https://test.petal.social'
export const BASE_URL = 'https://www.petal.social'
export const POST_URL = ''

// export const LINE_CHANNEL = '1654302319' // For test env
// export const LINE_CHANNEL = '1654296784' // For UAT
export const LINE_CHANNEL = '1654302591' // For PRD

export const SMALL_GIFT = 2000
export const MIDDLE_GIFT = 20000
export const BIG_GIFT = 200000



// WEBPACK FOOTER //
// ./src/constants.js